import type { Services } from "@/lib/services"

export const emptyServicesCollection: Services.Collection<object> = {
  acupuncture: {},
  chiropractic: {},
  hand_therapy: {},
  massage: {},
  osteopathy: {},
  physiotherapy: {},
  podiatry: {},
}

export const serviceLabels: Services.Options = {
  acupuncture: `Acupuncture`,
  chiropractic: `Chiropractic`,
  hand_therapy: `Hand Therapy`,
  massage: `Massage`,
  osteopathy: `Osteopathy`,
  physiotherapy: `Physiotherapy`,
  podiatry: `Podiatry`,
}

export const serviceLabelEntries = Object.entries(serviceLabels) as [
  Services.Option,
  Services.Label
][]

export const defaultServiceOption = `physiotherapy`

export const defaultServiceLabel = serviceLabels[defaultServiceOption]
